import { MachineRegistration } from "@myfamilysrl/techla_ts_sdk";
import { atom } from "recoil";

const initalData: MachineRegistration[] | undefined = [];

export const machinesDataState = atom({
  key: "machinesDataState",
  default: initalData,
});
